import {
  Fieldset,
  Slider,
  Text,
  TokenTextAppearance,
  TextTag,
  styled,
} from '@volkswagen-onehub/components-core';
import React, {useContext, useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from '../../../../store/hooks';
import {set} from '../../../../store/slice/timeline';
import {Timelines} from '../../../../types/timeline';
import useTrans from '../../../../hooks/use-trans';
import {formatDistance} from '../../../../utils/distance';
import useGetLang from '../../../../hooks/use-get-lang';
import {
  TrackingContext,
  TrackingEvents,
} from '../../../../store/context/modules/TrackingContext';

interface MileageInterface {
  timelines: Timelines;
}

const MileageContainer = styled.div`
  width: 100%;

  div[role='slider'] {
    &:focus-within {
      background-color: #4cc7f4;
    }
  }
`;

export default ({timelines}: MileageInterface) => {
  const trackCtx = useContext(TrackingContext);
  const vehicle = useAppSelector((state) => state.vehicle.value);

  const [min, setMin] = useState<number | null>(null);
  const [max, setMax] = useState<number | null>(null);

  const dispatch = useAppDispatch();
  const trans = useTrans();
  const lang = useGetLang();

  const onMileageChange = (e: number) => {
    dispatchMileage(e);

    trackCtx?.init(
      TrackingEvents.FILTER_SELECT_CLICK,
      (vehicle?.model as string).toUpperCase(),
      (vehicle?.model as string).toUpperCase() + '-SELECT MILEAGE',
      {name: (vehicle?.model as string).toUpperCase() + ' : SELECT : MILEAGE'},
      {
        type: 'range',
        name: 'KR',
        lowerbound: min,
        upperbound: max,
        values: e,
      },
      null,
      {
        name:
          (vehicle?.model as string).toLowerCase() + '-process-select-mileage',
        number: 5,
        processComplete: true,
      },
    );
  };

  const dispatchMileage = (mileage: number) => {
    dispatch(set({value: {[mileage]: timelines[mileage]}}));
  };

  useEffect(() => {
    const parsedMileage = Object.keys(timelines).map(Number);

    setMin(Math.min(parsedMileage[0]));
    setMax(Math.max(parsedMileage[parsedMileage.length - 1]));

    dispatchMileage(parsedMileage[0]);
  }, []);

  const distance = (km: number) => formatDistance(km, lang);

  return (
    <MileageContainer>
      <Fieldset>
        <legend id="vehicle-mileage-slider">
          <Text
            appearance={TokenTextAppearance.headline300}
            bold
            tag={TextTag.span}
          >
            {trans.vehicle_mileage}
          </Text>
        </legend>

        {min && max && (
          <Slider
            onChange={(e) => onMileageChange(e)}
            hideMinMax
            showIntervals
            min={min}
            max={max}
            step={15000}
            defaultValue={15000}
            getValueText={(value) => distance(value)}
            ariaLabelledby="vehicle-mileage-slider"
          />
        )}
      </Fieldset>
    </MileageContainer>
  );
};
